import { render, staticRenderFns } from "./component-bg-image.vue?vue&type=template&id=29f18a77"
import script from "./component-bg-image.vue?vue&type=script&lang=js"
export * from "./component-bg-image.vue?vue&type=script&lang=js"
import style0 from "./component-bg-image.vue?vue&type=style&index=0&id=29f18a77&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports